import { Pagination, Paper, Table } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SearchTableHeaders } from './SearchTableHeaders';
import { SearchTableBody } from './SearchTableBody';
import { StandardButton } from '../buttons/StandardButton';
import { useStyles } from '../styles/TableStyles.styles';
import { AppRoutes } from '@consts/routes';

import type { Manufacturer, Model } from '@features/redux/slices/designSlice';
import type { Dictionary } from '@/types/general';

interface ModelTableProps {
    selectModel: (model: Model) => void;
    selectPage: (page: number) => void;
    models: Model[];
    manufacturerMap: Dictionary<Manufacturer>;
    pageCount: number;
    pageNumber: number;
    loadingModel: boolean;
}

const HEADERS = ['Manufacturer', 'Model', ''];

export const ModelTable = ({
    selectModel,
    selectPage,
    models,
    manufacturerMap,
    pageCount,
    pageNumber,
    loadingModel,
}: ModelTableProps) => {
    const styles = useStyles();

    const navigate = useNavigate();

    return (
        <Paper>
            <Table>
                <SearchTableHeaders rows={HEADERS} />

                <SearchTableBody
                    numCols={HEADERS.length}
                    emptyListText={'No Models Found'}
                    loading={loadingModel}
                    rows={models.map((device, index) => {
                        const manufacturer = manufacturerMap[device.manufacturerId];

                        return [
                            {
                                value: manufacturer ? manufacturer.manufacturerName : 'Not Found',
                                isButton: false,
                            },
                            { value: device.model, isButton: false },
                            {
                                value: [
                                    <StandardButton
                                        key={`${index}view`}
                                        text={'Designs'}
                                        onClick={() =>
                                            navigate({
                                                pathname: AppRoutes.Design,
                                                search: `?model=${device.modelId}&manufacturer=${device.manufacturerId}`,
                                            })
                                        }
                                    />,
                                    <StandardButton
                                        key={`${index}edit`}
                                        text={'Edit'}
                                        onClick={() => selectModel(device)}
                                    />,
                                ],
                                isButton: true,
                            },
                        ];
                    })}
                />
            </Table>

            <div className={styles.pagination}>
                <Pagination
                    color={'primary'}
                    onChange={(_, page) => selectPage(page)}
                    count={pageCount}
                    page={pageNumber}
                />
            </div>
        </Paper>
    );
};
